import React from 'react';

import './index.css';

export default function BlockText({ blockOfText }) {
  return <div className="blockText">{blockOfText}</div>;
}
